<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-center" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6">Cases</h6>
<div class="row" *ngIf='displayState.filterDiv'>
    <div class="col-md-12" style="padding-top: 5px;">
        <div class="card bg-light">
            <div class="card-body" style="background-color:#e9ecef">
                <div class="form-row" *ngIf="!displayState.altSearches">
                    <div style="margin-right: 20px;" *ngIf='allowNewCase'>
                        <button class="btn btn-info btn-sm" title="Click to create a new Case" (click)="newCase()">New Case</button>
                    </div>
                    <div style="margin-left: 20px;">
                    <label for="selYear" style="padding-right: 10px;" class="col-form-label prd-label">Case Year</label>
                        <select title="Select Case Year to display all associated cases" id="selYear" [(ngModel)]='caseYear' >
                            <option></option>
                            <option *ngFor="let yr of yearList">{{yr}}</option>
                        </select>
                        <button style="margin-left: 5px;" class="btn btn-success btn-sm" (click)="changeYear()">Get Cases</button>
                    </div>

                    <div style="margin-left: 30px; text-align: right;">
                        <label class="col-form-label prd-label" style="padding-right: 10px;">Case #</label>
                        <p-inputMask size="7" title="Enter (full or partial) Case#, then press RETURN (or click button on right)" [(ngModel)]="searchString.caseNum" mask="99-?9999" (keyup.enter)="findByCaseNum()"></p-inputMask>
                        <button style="margin-left: 5px;" class="btn btn-success btn-sm" (click)="findByCaseNum()">Get Case</button>
                    </div>
                    <div style="margin-left: 30px; text-align: right;">
                        <label class="col-form-label prd-label" style="padding-right: 10px;">APN</label>
                        <input type="text" title="Enter (partial) APN, then press RETURN (or click button on right)" class="input-sm" [(ngModel)]="searchString.APN" (keyup.enter)="findByAPN()"  />
                        <!--<p-inputMask title="Enter an APN, then press RETURN (or click button on right)" [(ngModel)]="searchString.APN" mask="" unmask="true" (keyup.enter)="findByAPN()"></p-inputMask>-->
                        <button style="margin-left: 5px;" class="btn btn-success btn-sm" (click)="findByAPN()">Get List</button>
                    </div>
                    <div style="margin-left: 30px; text-align: right;">
                        <label class="col-form-label prd-label" style="padding-right: 10px;">Applicant</label>
                        <input type="text" title="Enter (partial) Applicant LAST name, then press RETURN (or click button on right)" class="input-sm" [(ngModel)]="searchString.applicant" (keyup.enter)="findByApplicant()"  />
                        <button style="margin-left: 5px;" class="btn btn-success btn-sm" (click)="findByApplicant()">Get List</button>
                    </div>
                    <div style="margin-left: 30px; text-align: right;">
                        <label class="col-form-label prd-label" style="padding-right: 10px;">Appraiser (Open Cases)</label>
                        <select [(ngModel)]="searchString.appraiserId" title="Select an Appraiser">
                            <option *ngFor="let appraiser of appraiserChoiceList" value="{{appraiser.id}}">{{appraiser.name}}</option>
                        </select>
                        <button style="margin-left: 5px;" class="btn btn-success btn-sm" (click)="findByAppraiser()">Get List</button>
                    </div>
                    <div style="margin-left: 10px; text-align: right;">
                        <button class="btn btn-sm btn-link" (click)='showAltSearches(true)' title="Alternative Case lookups, e.g. Complex Cases, etc.">Alt Lookups</button>
                    </div>
                </div>
                <div *ngIf='displayState.altSearches'>
                  <div class="row">
                      <div class="col-md-2">
                        <input  id="complexCase" type="checkbox" class="prd-checkbox col-sm-1" title="Check if only want Complex Cases" [(ngModel)]='altSearchString.complexCase'>
                        <label for="complexCase" class="prd-label">Complex Case</label>
                      </div>
                      <div class="col-md-3">
                        <div style="text-align: left;">
                          <label class="prd-label" style="padding-right: 10px;">Special Case Identifier</label>
                          <select [(ngModel)]="altSearchString.specialCaseIdentifier">
                            <option *ngFor="let anOpt of assessorSpecialCaseChoiceList">{{anOpt.specialCase}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div style="margin-left: 5px;">
                          <label for="rollYear" class="prd-label" style="padding-right: 10px;">Roll Year</label>
                          <select id="rollYear" title="Select Roll Year to display all associated cases" [(ngModel)]='altSearchString.rollYear' >
                            <option></option>
                            <option *ngFor="let yr of rollYearList">{{yr}}</option>
                          </select>
                        </div>
                      </div>
                    <div class="col-md-2">
                      <button style="margin-left: 5px;" class="btn btn-success btn-sm" title="Get list of cases that match the filter(s)" (click)="findByAltSearch()">Get List</button>
                    </div>
                    <div class="col-md-1">
                      <button class="btn btn-sm btn-link" title="Revert back to regular Case search filters" (click)="showAltSearches(false)">Lookup by Year</button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br />
<div class="row" [hidden]='!this.displayState.workingDiv'>
  <div class="col-md-12">

<div class="card">
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
            </div>
        </div>
      </div>
</div>
  </div>
</div>
<div class="row" *ngIf='displayState.gridDiv'>
    <div class="col-md-12">
        <div class="card">
            <div class="card-body" style="background-color:#e9ecef">
                <p-table #dt [value]="caseList"
                         [scrollable]="true"
                         scrollHeight="480px"
                         styleClass="p-datatable-striped  p-datatable-gridlines"
                         [showCurrentPageReport]="true"
                         [rows]="5"
                         [rowsPerPageOptions]="[5, 10, 25, 50]"
                         [paginator]="false"
                         [resizableColumns]="true"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of cols; let i = index" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="i>0" field="{{col.field}}"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-appCase>
                        <tr style="font-size: small">
                            <td>
                                <button class="btn btn-link" (click)="onSelect(appCase)"> Select </button>
                            </td>
                            <td>{{ appCase.caseNumber }}</td>
                            <td>{{ appCase.dateReceived | date: 'M/d/yyyy' }}</td>
                            <td title="{{appCase.applicantName}}">{{ appCase.applicantName }}</td>
                            <td title="{{appCase.agencyName}}">{{ appCase.agencyName }}</td>
                            <td>{{ appCase.propSecured }}</td>
                            <td>{{ appCase.propNumber | APN: '-' }}</td>
                            <td title="{{appCase.situs}}">{{ appCase.situs }}</td>
                            <td>{{ appCase.status }}</td>
                        </tr>
                    </ng-template>
                    <ng-template *ngIf="caseList" pTemplate="summary">
                        <div class="row">
                            <div class="col-md-2 offset-1" style="text-align: left;"># of cases: {{ caseList.length }}</div>
                            <div class="col-md-4 offset-1" [hidden]="true">
                              <button type="button" class="btn btn-info btn-sm" (click)="exportExcel()" >Export to Excel</button>
                            </div>
                        </div>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
